// src/services/withdrawService.js - SECURED
import { API_BASE_URL } from '../utils/constants';

const getAuthHeaders = () => {
  return {
    'Content-Type': 'application/json',
  };
};

const handleResponse = async (response) => {
  if (!response.ok) {
    if (response.status === 401) {
      window.location.href = '/';
    }
    const error = await response.json();
    throw new Error(error.error || error.detail || 'Request failed');
  }
  return response.json();
};

export const withdrawService = {
  // Create bank withdrawal
  createBankWithdrawal: async (amount, bankDetails = {}) => {
    try {
      const url = `${API_BASE_URL}/withdraw/withdraw/bank/`;
      console.log('🌐 Making bank withdrawal request to:', url);
      
      const requestData = {
        amount: amount,
        ...bankDetails
      };
      
      const response = await fetch(url, {
        method: 'POST',
        headers: getAuthHeaders(),
        credentials: 'include',
        body: JSON.stringify(requestData),
      });
      
      const data = await handleResponse(response);
      
      // Ensure response has reference_id
      if (!data.reference_id && data.id) {
        data.reference_id = `WDR${data.id.toString().padStart(8, '0')}`;
      }
      
      return data;
    } catch (error) {
      console.error('💥 Bank withdrawal error:', error);
      throw error;
    }
  },

  // Create crypto withdrawal
  createCryptoWithdrawal: async (withdrawalData) => {
    try {
      const url = `${API_BASE_URL}/withdraw/withdraw/crypto/`;
      console.log('🌐 Making crypto withdrawal request to:', url);
      
      const response = await fetch(url, {
        method: 'POST',
        headers: getAuthHeaders(),
        credentials: 'include',
        body: JSON.stringify(withdrawalData),
      });
      
      const data = await handleResponse(response);
      
      // Ensure response has reference_id
      if (!data.reference_id && data.id) {
        data.reference_id = `WDR${data.id.toString().padStart(8, '0')}`;
      }
      
      return data;
    } catch (error) {
      console.error('💥 Crypto withdrawal error:', error);
      throw error;
    }
  },

  // Get user withdrawal history
  getWithdrawalHistory: async () => {
    try {
      const url = `${API_BASE_URL}/withdraw/withdraw/history/`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: getAuthHeaders(),
        credentials: 'include',
      });
      
      return handleResponse(response);
    } catch (error) {
      console.error('💥 Error fetching withdrawal history:', error);
      throw error;
    }
  },

  // Get withdrawal limits
  async getWithdrawalLimits() {
    try {
      const url = `${API_BASE_URL}/withdraw/limits/`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: getAuthHeaders(),
        credentials: 'include',
      });
      
      return handleResponse(response);
    } catch (error) {
      console.error('💥 Error fetching withdrawal limits:', error);
      throw error;
    }
  },

  // Cancel withdrawal
  async cancelWithdrawal(withdrawalId) {
    try {
      const url = `${API_BASE_URL}/withdraw/withdraw/${withdrawalId}/cancel/`;
      
      const response = await fetch(url, {
        method: 'POST',
        headers: getAuthHeaders(),
        credentials: 'include',
      });
      
      return handleResponse(response);
    } catch (error) {
      console.error('💥 Error canceling withdrawal:', error);
      throw error;
    }
  },

  // Get withdrawal statistics
  async getWithdrawalStatistics() {
    try {
      const url = `${API_BASE_URL}/withdraw/statistics/`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: getAuthHeaders(),
        credentials: 'include',
      });
      
      return handleResponse(response);
    } catch (error) {
      console.error('💥 Error fetching withdrawal statistics:', error);
      throw error;
    }
  }
};

export default withdrawService;